import store from '@/store'
import { Operations } from '@/modules/Operations'

export let $timeout = null

export function $getNumberOfTransactions () {
  if (!IS_ANDROID) return

  clearTimeout($timeout)

  Banking.getNumberOfTransactions(number => {
    store.dispatch('setTransactions', { type: 'pax', number: number })
  })
  Donation.getNumberOfTransactions(number => {
    store.dispatch('setTransactions', { type: 'donation', number: number })
  })
  Tip.getNumberOfTransactions(number => {
    store.dispatch('setTransactions', { type: 'tips', number: number })
  })
  CashlessTransaction.getNbTransactions(number => {
    store.dispatch('setTransactions', { type: 'cashless', number: number.count })
    store.dispatch('setTransactions', { type: 'cashlessCa', number: number.ca })
  })

  setTimeout(_ => {
    // Si connecté à internet et transactions en attente
    if (store.getters.totalTransactions > 0 && store.getters.isConnected) {
      const promises = []

      if (store.state.transactions.pax > 0) {
        promises.push(Operations.sendBankingTransactions())
      }
      if (store.state.transactions.donation > 0) {
        promises.push(Operations.sendDonTransactions())
      }
      if (store.state.transactions.tips > 0) {
        promises.push(Operations.sendPourboireTransactions())
      }
      if (store.state.transactions.cashless > 0) {
        promises.push(Operations.sendOfflineTransactions())
      }

      Promise.all(promises)
        .then(() => {
          $timeout = setTimeout($getNumberOfTransactions, 800)
        })
        .catch(() => {
          $timeout = setTimeout($getNumberOfTransactions, 60000)
        })
    } else {
      $timeout = setTimeout($getNumberOfTransactions, 60000)
    }
  }, 800)
}
